export default __webpack_public_path__ + "static/media/jntua-p.604a8c1a.jpg";